import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BrandmarkCoinBg from '../assets/brandmark-coin-bg.png';
import { Colors } from '../constants';

function SVGNode(props) {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.children}
    </svg>
  );
}

export const SVG = styled(SVGNode)``;

export class UniqueComponent extends Component {
  constructor(props) {
    super(props);
    this.token = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '');
  }

  uniqueName = (name) => {
    return `${name}-${this.token}`;
  };

  uniqueId = (name) => {
    return `#${this.uniqueName(name)}`;
  };

  uniqueUrl = (name) => {
    return `url(${this.uniqueId(name)})`;
  };
}

export class Brandmark extends Component {
  static propsTypes = {
    color: PropTypes.String,
    className: PropTypes.String,
  };
  static defaultProps = {
    color: undefined,
    className: undefined,
  };

  render() {
    return (
      <SVG className={this.props.className} style={this.props.style} viewBox="0 0 50 50">
        <g fill={this.props.color} fillRule="evenodd">
          <path d="M25 0c13.807 0 25 11.193 25 25S38.807 50 25 50 0 38.807 0 25 11.193 0 25 0zm9.545 15.314h-1.796a2.338 2.338 0 00-2.338 2.339v4.387a3.326 3.326 0 01-3.326 3.325h-1.326a.76.76 0 00-.504 1.328l8.93 7.923a.543.543 0 00.903-.406V15.857c0-.3-.243-.543-.543-.543zm-19.086-.067c-.3 0-.542.243-.542.543v18.353c0 .3.243.543.542.543h1.796a2.338 2.338 0 002.338-2.339V27.96a3.326 3.326 0 013.326-3.325h1.326a.76.76 0 00.504-1.328l-8.93-7.923a.543.543 0 00-.36-.137z" />
        </g>
      </SVG>
    );
  }
}

export class Wordmark extends Component {
  static propsTypes = {
    color: PropTypes.String,
    className: PropTypes.String,
  };
  static defaultProps = {
    color: 'currentColor',
    className: undefined,
  };

  render() {
    return (
      <SVG viewBox="0 0 249 86" className={this.props.className}>
        <path
          fill={this.props.color}
          fillRule="nonzero"
          d="M248 71v15H0V71h248zM93.4 17.2c12.5 0 20.2 7.7 20.2 20.6l-.2 3.8h-28c.2 4.6 4.3 7.8 9 7.8 4.5 0 7-2.1 8.2-5.3l10.3 3c-2 7-8.4 12.8-18.6 12.8-11 0-21-8-21-21.5 0-13 9.7-21.2 20.1-21.2zM194 4.9c5 0 8.9 1 11 2.1l-3.4 10.4c-2.5-.9-5.4-1.7-8.3-1.7-8.7 0-15.5 4.3-17 13.4 1.9-3 6.3-5.5 12.5-5.5 10.7 0 17.6 7.3 17.6 17.5 0 10.7-8.6 18.8-20.8 18.8-12.5 0-21.8-9.1-21.8-24.2 0-18.6 12-30.8 30.2-30.8zM19.3 6.6v11.8H27v10.8h-7.8v15c0 3.3 1.8 4.2 4.4 4.2 1.3 0 2.5-.2 3.3-.4v10.2c-.5.3-2.5 1.2-6.4 1.2-8.4 0-13.5-5-13.5-13V29.2H0V18.4h2c4.2 0 6.3-2.8 6.3-6.6V6.6h11zm24-6.6v21c2.5-2.5 6.7-3.7 10.3-3.7 10.5 0 15.2 7.2 15.2 16v25.3H56.5V35.5c0-4-2.1-7-6.6-7-3.9 0-6.4 2.8-6.6 6.5v23.6H31V0h12.3zm114.5 6v52.6H145V24.5h-12.5V16c7.8-.1 13.4-4.6 14.3-10h11zm90.4 0v10.3a62 62 0 00-20.6 42.3h-13.3a65.6 65.6 0 0118.8-41.8h-25.8V6h40.9zM188.4 34c-4.6 0-8.2 3-8.2 7.7 0 4.4 3.6 7.6 8.2 7.6 4.5 0 8.2-3 8.2-7.6 0-4.7-3.7-7.7-8.2-7.7zm-94.8-7a7.7 7.7 0 00-8 6.8h16.1c-.2-3-2.3-6.8-8.1-6.8z"
        />
      </SVG>
    );
  }
}

export class Logo extends Component {
  static propsTypes = {
    color: PropTypes.String,
    className: PropTypes.String,
  };
  static defaultProps = {
    color: undefined,
    className: undefined,
  };

  render() {
    let { style } = this.props;
    style = style || {};

    return (
      <SVG className={this.props.className} style={style} viewBox="0 0 176 50">
        <g fill={this.props.color} fillRule="evenodd">
          <path d="M25 0c13.807 0 25 11.193 25 25S38.807 50 25 50 0 38.807 0 25 11.193 0 25 0zm9.545 15.314h-1.796a2.338 2.338 0 00-2.338 2.339v4.387a3.326 3.326 0 01-3.326 3.325h-1.326a.76.76 0 00-.504 1.328l8.93 7.923a.543.543 0 00.903-.406V15.857c0-.3-.243-.543-.543-.543zm-19.086-.067c-.3 0-.542.243-.542.543v18.353c0 .3.243.543.542.543h1.796a2.338 2.338 0 002.338-2.339V27.96a3.326 3.326 0 013.326-3.325h1.326a.76.76 0 00.504-1.328l-8.93-7.923a.543.543 0 00-.36-.137z" />
          <path
            d="M62.5 34.044V17.976c0-.19.155-.345.345-.345h3.644c.158 0 .295.106.334.259l.503 1.953c.805-1.34 2.782-2.614 5.262-2.614 3.285 0 5.765 2.111 5.765 6.502v10.313c0 .19-.154.345-.345.345h-4.404a.345.345 0 01-.345-.345v-9.24c0-1.978-1.006-3.05-2.682-3.05-1.541 0-2.983 1.273-2.983 4.155v8.135c0 .19-.154.345-.345.345h-4.404a.345.345 0 01-.345-.345zM85.29 17.63c.191 0 .346.154.346.345v9.308c0 1.944 1.106 2.983 2.715 2.983 1.642 0 3.05-1.274 3.05-4.09v-8.201c0-.19.154-.345.345-.345h4.404c.19 0 .345.154.345.345v16.068c0 .19-.155.345-.345.345h-3.644a.345.345 0 01-.334-.259l-.503-1.953c-.805 1.34-2.816 2.614-5.296 2.614-3.318 0-5.832-2.145-5.832-6.535v-10.28c0-.19.155-.345.345-.345h4.405zm22.075-.383c3.587 0 6.114 1.499 7.58 4.496a.333.333 0 01-.152.445l-.018.008-4.02 1.677a.332.332 0 01-.433-.174c-.596-1.358-1.626-2.038-3.091-2.038-2.176 0-3.681 1.773-3.681 4.348 0 2.542 1.64 4.348 3.815 4.348 1.265 0 2.25-.588 2.956-1.762l.121-.213a.332.332 0 01.419-.15l4.024 1.65a.333.333 0 01.163.471c-1.67 2.946-4.276 4.418-7.817 4.418-5.02 0-8.802-3.511-8.802-8.762 0-5.25 3.916-8.762 8.936-8.762zm25.64-.02c5.899 0 8.596 4.132 8.58 8.212.013.44-.035.96-.146 1.56a.345.345 0 01-.34.284h-11.58c.436 2.212 1.843 3.15 3.754 3.15 1.482 0 2.591-.561 3.327-1.683a.345.345 0 01.442-.12l3.579 1.775a.345.345 0 01.143.486c-1.534 2.567-4.11 3.867-7.726 3.9-5.094.045-8.613-3.52-8.613-8.782 0-5.296 3.485-8.781 8.58-8.781zm-10.8-5.043a.345.345 0 01.002.043v21.816c0 .19-.154.345-.345.345h-4.403a.345.345 0 01-.338-.276l-.007-.07.084-21.283c0-.174.13-.32.303-.341l4.319-.534a.345.345 0 01.385.3zm11.135 8.917c-1.474 0-3.184.718-3.72 2.796h7.36c-.336-1.81-1.964-2.796-3.64-2.796zm15.226-3.471c.19 0 .345.154.345.345v9.308c0 1.944 1.107 2.983 2.715 2.983 1.643 0 3.05-1.274 3.05-4.09v-8.201c0-.19.155-.345.345-.345h4.405c.19 0 .345.154.345.345v16.068c0 .19-.155.345-.345.345h-3.644a.345.345 0 01-.335-.259l-.503-1.953c-.804 1.34-2.815 2.614-5.295 2.614-3.318 0-5.832-2.145-5.832-6.535v-10.28c0-.19.155-.345.345-.345h4.404zm20.006-.402c2.556-.03 4.367.905 5.433 2.804a.345.345 0 01-.132.47l-.007.004-3.035 1.615a.345.345 0 01-.465-.14c-.4-.733-.942-1.1-1.626-1.1-.738 0-1.24.402-1.24 1.005 0 .57.335.905 1.106 1.207l2.279.838c2.614.972 4.323 2.547 4.323 5.53 0 3.084-2.58 5.33-6.67 5.33-3.362 0-5.581-1.373-6.656-4.118a.345.345 0 01.178-.44l3.228-1.472a.345.345 0 01.447.15c.695 1.288 1.675 1.94 2.938 1.958 1.273 0 1.877-.637 1.877-1.34 0-.705-.57-1.274-2.011-1.81l-2.078-.772c-2.28-.838-3.654-2.413-3.654-4.96 0-2.782 2.48-4.76 5.765-4.76z"
            fillRule="nonzero"
          />
        </g>
      </SVG>
    );
  }
}

export class BrandmarkCoin extends Component {
  static propsTypes = {
    color: PropTypes.String,
    className: PropTypes.String,
  };
  static defaultProps = {
    color: undefined,
    className: undefined,
  };

  render() {
    return (
      <div className={this.props.className}>
        <SVG viewBox="0 0 116 120">
          <defs>
            <filter x="-209.7%" y="-111.3%" width="519.4%" height="320.1%" filterUnits="objectBoundingBox" id="a">
              <feOffset dy="20" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
                in="shadowBlurOuter1"
                result="shadowMatrixOuter1"
              />
              <feMerge>
                <feMergeNode in="shadowMatrixOuter1" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g transform="translate(-16 -15)" fill="none" fillRule="evenodd">
            <circle fill="#4ED6E0" cx="73.452" cy="74.452" r="40.581" />
            <image
              transform="scale(-1 1) rotate(-20 0 494.675)"
              x="17"
              y="16"
              width="114"
              height="118"
              xlinkHref={BrandmarkCoinBg}
            />
            <g
              filter="url(#a)"
              transform="rotate(-24 152.466 -84.158)"
              stroke="#FFF"
              strokeLinejoin="round"
              strokeWidth="5.156"
            >
              <ellipse strokeLinecap="round" cx="20.962" cy="10.042" rx="10.016" ry="10.013" />
              <path d="M9.372 56.373L.622 22.165l26.46 11.765-7.312 10.456 7.164 10.61" />
            </g>
          </g>
        </SVG>
      </div>
    );
  }
}

export const Arrow = (props) => {
  return (
    <SVG viewBox="0 0 34 30" {...props}>
      <g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeWidth="6">
        <path d="M3.8 14.9h27M21.7 3.5l9.1 11.2M21.7 26.3L30.8 15" />
      </g>
    </SVG>
  );
};

export const ArrowLoop = (props) => {
  return (
    <SVG viewBox="0 0 363 120" {...props}>
      <g fillRule="nonzero" stroke="currentColor" strokeWidth="7" fill="none" strokeLinecap="round">
        <path
          d="M4 95.722c81.319 2.715 137.119-3.99 167.4-20.114 45.42-24.187 24.987-60.613 0-69.028-24.988-8.416-53.554 4.632-63.455 26.48-9.902 21.848 2.277 61.37 41.88 76.786 39.602 15.415 106.719-1.73 141.65-22.92 23.287-14.129 41.72-40.851 55.299-80.169L312.75 33.06"
          strokeLinejoin="round"
        />
        <path d="M349 6l9.97 46.394" />
      </g>
    </SVG>
  );
};

export const ArrowSwoopShort = (props) => {
  return (
    <SVG viewBox="0 0 137 118" {...props}>
      <g
        fillRule="nonzero"
        stroke={props.color || 'currentColor'}
        strokeWidth="7"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.001 4c-.128 23.85 8.961 45.27 27.27 64.263C59.825 91.939 92.068 102.368 128 99.55" />
        <path d="M110 83l23 18.71L110 114" />
      </g>
    </SVG>
  );
};

export const ArrowSwoop = (props) => {
  return (
    <SVG viewBox="0 0 172 201" {...props}>
      <g
        fillRule="nonzero"
        stroke={props.color || 'currentColor'}
        strokeWidth="7"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.002 4C3.838 47.526 15.418 86.62 38.74 121.283c36.378 43.21 77.454 62.244 123.227 57.101" />
        <path d="M139.22 155.57L168 182.79l-28.78 14.049" />
      </g>
    </SVG>
  );
};

export const Spinner = (props) => {
  return (
    <SVG viewBox="0 0 36 36" className={props.className}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="4.3"
        d="M18 33a15 15 0 1 0-15-15"
      />
    </SVG>
  );
};

export const ShortUnderline = (props) => {
  return (
    <SVG viewBox="0 0 39 6" {...props}>
      <path
        d="M1 5c8.703-.91 25.99-7.514 37-1.497"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        fillRule="evenodd"
      />
    </SVG>
  );
};

export const X = (props) => {
  return (
    <SVG className={props.className} viewBox="0 0 16 16" {...props}>
      <g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeWidth="2.8">
        <path d="M1.5 1.5l13 13M14.5 1.5l-13 13" />
      </g>
    </SVG>
  );
};

export const DottedLineSwoop = (props) => {
  return (
    <SVG className={props.className} viewBox="0 0 125 145" {...props}>
      <defs>
        <linearGradient x1="100%" y1="100%" y2="0%" id="dottedswoop">
          <stop stopColor="#FFF" stopOpacity="1" offset="1%" />
          <stop stopColor="#FFF" stopOpacity="0" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M1101.544 1056.976c25.37 67.218 10.726 129.551-43.936 187"
        transform="scale(-1 1) rotate(28 2668.295 -1685.635)"
        stroke="url(#dottedswoop)"
        strokeWidth="4"
        fill="none"
        fillRule="evenodd"
        strokeDasharray="6"
      />
    </SVG>
  );
};

const Wave1 = styled.div`
  margin-top: ${(props) => (props.collapseTop ? -1 * (128 / 1400) * 100 : 0)}%;
  margin-bottom: ${(props) => (props.collapseBottom ? -1 * (128 / 1400) * 100 : 0)}%;
  background-color: ${(props) => props.fromColor};
  z-index: 1;
  position: relative;
  display: block;

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: -1px;
    background: ${(props) => props.toColor};
  }
`;

export const SectionWave = (props) => {
  return (
    <Wave1 className={props.className} preserveAspectRatio="none" style={{}} {...props}>
      <SVG viewBox="0 0 1400 128" preserveAspectRatio="none" style={{ display: 'block' }}>
        <path
          d="M1400 64v64H0V64c192.667-84.667 381.333-84.667 566 0 184.667 84.667 462.667 84.667 834 0z"
          fill={props.toColor || 'currentColor'}
          fillRule="nonzero"
        />
      </SVG>
    </Wave1>
  );
};

export const ThumbsUpBubble = (props) => {
  return (
    <SVG {...props} viewBox="0 0 78 70">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#000000">
          <path
            d="M72.469,0.594 L6.184,0.594 C3.9301,0.594 0.1488,1.42603 0.1488,7.0002 L0.1488,51.2732 C0.1488,54.8084 2.4691,57.2771 5.7894,57.2771 L10.0902,57.2771 L10.0902,67.9101 C10.0902,68.41791 10.34801,68.89057 10.77379,69.1679 C11.01988,69.32806 11.30504,69.41009 11.5902,69.41009 C11.79723,69.41009 12.00426,69.36712 12.19958,69.28118 L39.25458,57.27718 L71.79358,57.27718 C75.52798,57.27718 77.84828,55.12488 77.84828,51.66388 L77.85219,6.99988 C77.85219,3.04678 75.78969,0.59368 72.46939,0.59368 L72.469,0.594 Z M74.8518,51.66 C74.8518,52.7811 74.53539,54.2733 71.7971,54.2733 L38.9381,54.27721 C38.72716,54.27721 38.52013,54.32018 38.32872,54.40612 L13.09472,65.60112 L13.09472,55.77692 C13.09472,54.9488 12.42284,54.27692 11.59472,54.27692 L5.79002,54.27692 C4.13772,54.27692 3.14942,53.15582 3.14942,51.27302 L3.14942,7.00002 C3.14942,4.48442 3.94239,3.59382 6.18462,3.59382 L72.46562,3.59382 C73.05546,3.59382 74.84842,3.59382 74.84842,7.00002 L74.8518,51.66 Z"
            id="Fill-1"
          ></path>
          <path
            d="M26.902,22.004 L16.668,22.004 C16.22659,22.004 15.80472,22.19931 15.5196,22.53916 C15.23444,22.879 15.11335,23.32822 15.19148,23.76576 L19.25788,46.83576 C19.38288,47.55451 20.00788,48.07406 20.73448,48.07406 L26.90248,48.07406 C27.7306,48.07406 28.40248,47.40218 28.40248,46.57406 L28.40248,23.50406 C28.40248,22.67594 27.7306,22.00406 26.90248,22.00406 L26.902,22.004 Z M25.402,45.074 L21.9918,45.074 L18.4527,25.004 L25.398,25.004 L25.402,45.074 Z"
            id="Fill-2"
          ></path>
          <path
            d="M60.891,22.773 C60.79725,22.75347 60.7035,22.74565 60.60975,22.74565 L48.85575,22.74565 C48.83622,22.39799 48.87528,21.9019 49.08622,21.23785 C49.84013,18.83165 50.13312,14.97225 49.262,12.87846 C48.57841,11.24566 47.1526,7.85116 43.3987,7.68705 C43.29714,7.68315 43.19948,7.68705 43.10182,7.70268 C41.12912,8.01127 40.05102,9.43318 39.72292,10.22998 C39.6487,10.40967 39.60964,10.60498 39.60964,10.80029 L39.60964,15.84719 C37.62524,19.43309 35.24634,23.47609 34.39874,24.55809 C33.52765,24.687 31.87144,24.89403 31.19564,24.97997 C30.44564,25.07372 29.88314,25.71044 29.88314,26.46827 L29.88314,43.51927 C29.88314,44.34739 30.55502,45.01927 31.38314,45.01927 L31.87923,45.01927 C34.84013,46.44507 38.48473,48.07007 39.74643,48.07007 L55.29343,48.07007 C55.40281,48.07007 55.50827,48.05835 55.61374,48.03491 C56.78954,47.7771 59.01604,46.52321 59.01604,43.62081 C59.01604,42.93722 58.85979,42.33561 58.63323,41.82781 C59.87543,41.15984 60.98873,39.96061 60.98873,37.95281 C60.98873,37.29656 60.75826,36.70671 60.44185,36.20281 C61.51215,35.44109 62.42235,34.22621 62.34025,32.44501 C62.33634,32.39423 62.33244,32.33954 62.32462,32.28876 C62.23869,31.71454 62.08634,31.21456 61.91446,30.78486 C63.03946,30.10127 64.07466,28.92156 64.07466,27.08176 C64.08638,24.15596 61.99656,22.98406 60.89106,22.77316 L60.891,22.773 Z M59.4926,28.5699 C58.95354,28.66365 58.51604,29.05428 58.3403,29.5738 C58.16452,30.09333 58.29342,30.6793 58.66452,31.0816 C58.68405,31.10504 59.18405,31.65582 59.35983,32.6597 C59.35202,33.8667 57.66843,34.2456 57.60593,34.2574 C57.01218,34.37459 56.55123,34.84334 56.43403,35.4371 C56.31684,36.03085 56.57075,36.6402 57.07075,36.9762 C57.49263,37.25745 57.96528,37.76526 58.00434,37.95276 C58.00434,39.29656 56.37544,39.50746 56.05904,39.53476 C55.43795,39.58163 54.91844,40.01132 54.73874,40.60896 C54.56296,41.20662 54.78171,41.85896 55.2778,42.23786 C55.28561,42.24567 56.03171,42.81989 56.03171,43.62066 C56.03171,44.59332 55.43796,44.94876 55.09812,45.06986 L39.80912,45.07377 C39.08256,44.99173 35.64892,43.50737 32.89502,42.17147 L32.89111,27.79247 C33.79345,27.67528 34.89891,27.52685 35.32471,27.45263 C36.10596,27.32763 36.78171,27.21825 42.43021,16.95663 C42.5513,16.73397 42.61771,16.48397 42.61771,16.23397 L42.61771,11.20277 C42.75052,11.03871 43.00443,10.80043 43.4263,10.69886 C45.0318,10.85902 45.7974,12.37076 46.5161,14.08556 C46.94579,15.12466 46.91063,18.14806 46.22704,20.33556 C45.2661,23.35116 46.46142,24.99576 46.59813,25.17146 C46.88329,25.53474 47.31688,25.74568 47.77783,25.74568 L60.39483,25.74568 C60.69171,25.85896 61.08233,26.18318 61.08233,27.08158 C61.08624,28.22998 59.64483,28.54248 59.49253,28.56988 L59.4926,28.5699 Z"
            id="Fill-3"
          ></path>
        </g>
      </g>
    </SVG>
  );
};

export const CurvedArrow = (props) => {
  return (
    <SVG {...props} className={props.className} viewBox="0 0 97 103">
      <g stroke="currentColor" fill="none" fillRule="evenodd">
        <path strokeWidth=".54rem" strokeLinecap="round" d="M53 92.3l2.5-19.7" />
        <path d="M21 19.1c49.6-15.6 59 53 31.4 73" strokeWidth=".45rem" strokeLinejoin="round" strokeLinecap="round" />
        <path strokeWidth=".54rem" strokeLinecap="round" d="M54.3 92L80 80" />
      </g>
    </SVG>
  );
};

const Wave2 = styled.div`
  margin-top: ${(props) => (props.collapseTop ? -1 * (89 / 1400) * 100 : 0)}%;
  margin-bottom: ${(props) => (props.collapseBottom ? -1 * (89 / 1400) * 100 : 0)}%;
  background-color: ${(props) => props.fromColor};
  z-index: 1;
  position: relative;
  display: block;
  bottom: -1px;
`;

export const SectionWaveShallow = (props) => {
  return (
    <Wave2 className={props.className} {...props}>
      <SVG viewBox="0 0 1400 89" preserveAspectRatio="none" style={{ display: 'block' }}>
        <path
          d="M1400 43.211V89H0V43c132.543-57.333 331.417-57.333 596.622 0 264.879 57.263 532.671 57.333 803.378.211z"
          fill={props.toColor || 'currentColor'}
          fillRule="evenodd"
        />
      </SVG>
    </Wave2>
  );
};

const Shape = styled.div`
  margin-top: ${(props) => (props.collapseTop ? -1 * (301 / 1400) * 100 : 0)}%;
  margin-bottom: ${(props) => (props.collapseBottom ? -1 * (301 / 1400) * 100 : 0)}%;
  background-color: ${(props) => props.fromColor};
  z-index: 1;
  position: relative;
  display: block;
  bottom: -1px;
`;

export const SectionSlopeTop = (props) => {
  return (
    <Shape className={props.className} {...props}>
      <SVG viewBox="0 0 1400 301" preserveAspectRatio="none" style={{ display: 'block' }}>
        <path
          d="M0 121.366l21.846-42.56C51.938 20.181 114.79-9.734 181.673 2.738l1087.734 202.826c56.007 10.444 102.858 47.555 130.558 95.436H0V121.366z"
          fill={props.toColor || 'currentColor'}
          fillRule="evenodd"
        />
      </SVG>
      {props.children}
    </Shape>
  );
};

export const SectionSlopeImageMask = (props) => {
  const Shape = styled.div`
    margin-top: ${(props) => (props.collapseTop ? -1 * (229 / 1400) * 100 : 0)}%;
    margin-bottom: ${(props) => (props.collapseBottom ? -1 * (229 / 1400) * 100 : 0)}%;
    background-color: ${(props) => props.fromColor};
    z-index: 1;
    position: relative;
    display: block;
    top: -1px;
  `;
  return (
    <Shape className={props.className} {...props}>
      <SVG viewBox="0 0 1400 229" preserveAspectRatio="none" style={{ display: 'block' }}>
        <path
          d="M1400 228.954L201.597 5.15C126.502-8.874 55.942 24.7 22.173 90.527L0 133.75V0h1400v228.954z"
          fill={props.toColor || 'currentColor'}
          fillRule="evenodd"
        />
      </SVG>
      {props.children}
    </Shape>
  );
};

export const UnderlineScribble = (props) => {
  return (
    <SVG className={props.className} viewBox="0 0 566 19" {...props}>
      <path
        d="M77.17 3.169C236.48-4.122 387.99 9.307 543.4 9.307c107.318 0-214.635-1.235-321.952 0-68.866.792-275.452 4.48-206.588 6.081 156.096 3.627 312.204 0 468.305 0 74.828 0-60.503-4.073-405.994-12.22z"
        fillRule="nonzero"
        stroke="#000"
        strokeWidth="3.5"
        fill="none"
        shapeRendering="optimizeQuality"
      />
    </SVG>
  );
};

export const Church = (props) => {
  return (
    <SVG className={props.className} viewBox="0 0 57 48" {...props}>
      <g fill={props.color || 'currentColor'} fillRule="nonzero">
        <path d="M27.08 1.315v1.477h-3.175a1.513 1.513 0 0 0-1.025.373 1.236 1.236 0 0 0-.427.921c0 .348.154.68.427.922.271.244.64.377 1.025.372h3.175v6.049L14.333 22.957H3.084V45.41H1.452a1.508 1.508 0 0 0-1.024.375 1.232 1.232 0 0 0-.428.922c0 .345.154.676.428.921.273.243.64.377 1.024.373H55.55c.382.004.75-.13 1.022-.373a1.24 1.24 0 0 0 .428-.921c0-.348-.154-.68-.428-.922a1.508 1.508 0 0 0-1.024-.375h-1.61V22.957H42.667L29.942 11.43V5.38h3.176c.384.005.751-.128 1.024-.372.274-.243.428-.574.428-.922 0-.345-.154-.679-.428-.921a1.518 1.518 0 0 0-1.024-.373h-3.176V1.315a1.23 1.23 0 0 0-.42-.935A1.516 1.516 0 0 0 28.49 0c-.873.073-1.427.645-1.41 1.315zm1.433 12.48l12.142 10.983V45.41h-7.09V34.59H23.432v10.82h-7.09V24.778l12.165-10.983h.006zM5.948 25.545h7.538V45.41H5.948V25.546zm37.571 0h7.558V45.41h-7.558V25.546zM26.3 37.176h4.405v8.232h-4.405v-8.232z" />
        <path d="M28.5 18.857c-2.848 0-5.182 2.317-5.182 5.143 0 2.826 2.336 5.143 5.182 5.143 2.848 0 5.182-2.317 5.182-5.143 0-2.826-2.336-5.143-5.182-5.143zm0 2.374c1.557 0 2.79 1.223 2.79 2.769s-1.233 2.77-2.79 2.77-2.79-1.224-2.79-2.77 1.233-2.77 2.79-2.77z" />
      </g>
    </SVG>
  );
};

export const HeartChatBubble = (props) => (
  <SVG className={props.className} viewBox="0 0 76 66">
    <path
      d="M59.607 0H16.892C7.992 0 .75 7.397.75 16.494v16.339c0 9.093 7.242 16.494 16.142 16.494h27.003l19.63 16.108V48.831c7.098-1.81 12.225-8.35 12.225-16V16.495C75.75 7.397 68.508 0 59.608 0h-.001zM33.251 25.166l-8.757 9.674-8.786-9.686c-2.063-2.259-2.063-5.76 0-7.96.955-1.013 2.309-1.579 3.809-1.579 1.4 0 2.695.493 3.632 1.398l1.313 1.263 1.333-1.234c1.025-.943 2.29-1.447 3.653-1.447 1.45 0 2.804.574 3.791 1.582 2.074 2.209 2.083 5.722.012 7.989zm27.54 0l-8.758 9.674-8.786-9.686c-2.062-2.259-2.062-5.76 0-7.96.958-1.016 2.312-1.582 3.812-1.582 1.4 0 2.695.493 3.633 1.398l1.312 1.263 1.333-1.234c1.025-.943 2.291-1.447 3.653-1.447 1.45 0 2.804.574 3.791 1.582 2.072 2.212 2.083 5.725.01 7.992z"
      fill={props.color}
      fillRule="nonzero"
    />
  </SVG>
);

export const DeadCreditCard = (props) => (
  <SVG className={props.className} viewBox="0 0 125 89">
    <g fill={props.color} fillRule="evenodd">
      <path
        d="M76.221 62H47.78c-.984 0-1.779.795-1.779 1.779 0 .984.795 1.778 1.779 1.778h16v5.332c0 3.92 3.187 7.111 7.11 7.111C74.813 78 78 74.809 78 70.89v-7.111c0-.984-.795-1.779-1.779-1.779zm-1.778 8.887a3.56 3.56 0 0 1-3.556 3.556 3.56 3.56 0 0 1-3.555-3.556v-5.332h7.11v5.332z"
        fillRule="nonzero"
      />
      <path d="M49.167 56a1.834 1.834 0 0 0 1.297-3.13l-2.37-2.37 2.37-2.37a1.834 1.834 0 0 0-2.594-2.593l-2.37 2.37-2.37-2.37a1.834 1.834 0 0 0-2.593 2.593l2.37 2.37-2.37 2.37a1.834 1.834 0 0 0 2.593 2.594l2.37-2.37 2.37 2.37c.36.356.827.536 1.297.536zM84.463 45.537a1.834 1.834 0 0 0-2.593 0l-2.37 2.37-2.37-2.37a1.834 1.834 0 0 0-2.593 2.593l2.37 2.37-2.37 2.37a1.834 1.834 0 0 0 2.593 2.594l2.37-2.37 2.37 2.37a1.838 1.838 0 0 0 2.593 0 1.834 1.834 0 0 0 0-2.593l-2.37-2.37 2.37-2.37a1.834 1.834 0 0 0 0-2.594z" />
      <path
        d="M112.5 0h-100C5.607 0 0 5.59 0 12.46v64.08C0 83.41 5.608 89 12.5 89h100c6.892 0 12.5-5.59 12.5-12.46V12.46C125 5.59 119.392 0 112.5 0zm0 85.442h-100c-4.927 0-8.93-3.991-8.93-8.901V28.48h117.859v48.06c.001 4.908-4.002 8.9-8.928 8.9zm8.93-71.202H3.57v-1.78c0-4.909 4.003-8.902 8.93-8.902h100c4.927 0 8.93 3.991 8.93 8.901v1.781z"
        fillRule="nonzero"
      />
    </g>
  </SVG>
);

export class ListCheckBox extends Component {
  static propsTypes = {
    color: PropTypes.String,
    className: PropTypes.String,
  };
  static defaultProps = {
    color: undefined,
    className: undefined,
  };

  render() {
    return (
      <SVG className={this.props.className} viewBox="0 0 26 25">
        <g fill={this.props.color} fillRule="evenodd">
          <path d="M7.193 10.36a1.32 1.32 0 0 0 0 1.867l4.756 4.666c.218.214.571.214.815 0l12.228-12a1.32 1.32 0 0 0 0-1.866 1.381 1.381 0 0 0-1.902 0L12.764 13.16c-.217.214-.571.214-.815 0l-2.853-2.8a1.381 1.381 0 0 0-1.903 0zm13.37 11.733H4.693c-.869 0-1.576-.693-1.576-1.547V4.974c0-.853.707-1.547 1.577-1.547h10.652c.76 0 1.358-.587 1.358-1.334 0-.746-.597-1.333-1.358-1.333H3.117C1.623.76.4 1.96.4 3.427v18.666c0 1.467 1.223 2.667 2.717 2.667H22.14c1.495 0 2.718-1.2 2.718-2.667V12.76c0-.747-.598-1.333-1.36-1.333-.76 0-1.358.586-1.358 1.333v7.787c0 .853-.707 1.546-1.576 1.546z" />
        </g>
      </SVG>
    );
  }
}

export class GraphLine extends Component {
  static propsTypes = {
    color: PropTypes.String,
    className: PropTypes.String,
  };
  static defaultProps = {
    color: undefined,
    className: undefined,
  };

  render() {
    return (
      <SVG className={this.props.className} viewBox="0 0 1400 669">
        <path
          d="M1.402 665.444l8.967-8.238a5 5 0 013.383-1.318h7.284a5 5 0 004.508-2.838l12.734-26.547a5 5 0 011.928-2.121l16.884-10.17a5 5 0 002.158-2.686l8.263-24.51a5 5 0 018.277-1.934l16.653 16.689a5 5 0 001.124.846l11.588 6.391a5 5 0 006.348-1.291l4.651-5.928a5 5 0 015.966-1.481l9.001 4.004a5 5 0 004.913-.481l22.586-15.92a5 5 0 001.451-1.59l13.337-23.137a5 5 0 015.694-2.314l8.344 2.364a5 5 0 012.02 1.13l12.738 11.706a5 5 0 011.49 2.566l1.602 6.996a4.992 4.992 0 008.294 2.515l15.407-14.556a5 5 0 001.117-1.562l11.06-24.292a5 5 0 014.551-2.928H261.3l14.058-29.54 6.77 14.912 14.408-4.497 4.304-6.76 11.723 16.063h12.167l13.637 17.001 14.893-18.097 12.113-42.638 7.723 9.332 12.538 7.923 18.499-42.068 28.464 30.894 18.567-6.08 14.252 21.143 21.699-56.992 10.377 16.73 23.153-26.2 23.354-56.596 19.298 37.133 24.239-22.84 22.256 16.52 11.164-11.319 12.773 21.873 21.83-16.12 31.211-37.216 11.281 11.969 15.294-20.328h29.58l19.511-22.519 14.362-36.983 12.449 59.502 26.905-22.519 13.377-41.195 26.423-37.903 41.258-30.974 20.559 30.974 26.59-14.672 24.954 31.394 24.485-40.595 23.426-7.1 8.653 24.658 22.366-49.89 10.768 15.784 13.597-35.913h21.27l18.453-65.494 14.089 39.206 8.598-17.187 13 43.475 18.479-18.847 27.068 64.207 26.088-88.835 15.938 17.187 34.678-72.03 14.715 19.394 18.841-36.745 14.03 6.325 7.51-44.226 19.91 19.389 18.098-11.869 15.355 4.02L1400 3"
          stroke={this.props.color || 'currentColor'}
          strokeWidth="6"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SVG>
    );
  }
}

export function ProChurchToolsH(props) {
  return (
    <SVG className={props.className} viewBox="0 0 1353 130">
      <g fill={props.color} fillRule="evenodd">
        <path d="M1128 26.3c22.7 0 40.7 15.9 40.7 39.6 0 23.6-18 39.5-40.7 39.5-22.7 0-40.7-15.9-40.7-39.5 0-23.7 18-39.6 40.7-39.6zm86.5 0c22.8 0 40.7 15.9 40.7 39.6 0 23.6-18 39.5-40.7 39.5-22.7 0-40.6-15.9-40.6-39.5 0-23.7 18-39.6 40.6-39.6zm108.1 0c11.8 0 20 4.3 24.5 12.7.4.7.2 1.7-.6 2l-13.8 7.4c-.7.4-1.6.1-2-.6-1.8-3.4-4.3-5-7.3-5-3.4 0-5.6 1.8-5.6 4.5 0 2.6 1.5 4 5 5.4l10.2 3.8c11.8 4.4 19.5 11.5 19.5 24.9 0 14.5-11.4 24-30 24-15.5 0-25.5-6.2-30-18.6-.3-.8 0-1.6.7-2l14.7-6.6c.7-.3 1.5 0 2 .6 3.3 6 7.7 9 13.2 9 5.7 0 8.4-3 8.4-6.1 0-3.2-2.5-5.7-9-8.2l-9.4-3.4c-10.3-3.8-16.5-10.9-16.5-22.3 0-12.6 11.2-21.5 26-21.5zm-37.7-25v100.8c0 .8-.6 1.5-1.5 1.5h-20c-.8 0-1.4-.7-1.4-1.5V4c0-.7.5-1.4 1.3-1.5l20-2.6c.7-.1 1.5.5 1.6 1.3zm-213.3 0v26.8h14.2c.9 0 1.5.7 1.5 1.5V44c0 .8-.6 1.5-1.5 1.5h-14.2V102c0 .8-.6 1.5-1.5 1.5h-19.9c-.8 0-1.5-.7-1.5-1.5V45.5h-9.8c-.9 0-1.5-.7-1.5-1.5V29.6c0-.8.6-1.5 1.5-1.5h9.8v-24c0-.7.6-1.4 1.3-1.5l20-2.6c.8-.1 1.5.5 1.6 1.3zm56.4 45c-9.9 0-17.7 8-17.7 19.6 0 11.4 7.8 19.6 17.7 19.6 10 0 17.6-8.2 17.6-19.6 0-11.7-7.7-19.7-17.6-19.7zm86.5 0c-9.8 0-17.7 8-17.7 19.6 0 11.4 7.9 19.6 17.7 19.6 10 0 17.6-8.2 17.6-19.6 0-11.7-7.7-19.7-17.6-19.7zM575.3 26.5c16.2 0 27.6 6.8 34.2 20.3.4.7 0 1.6-.7 2l-18.2 7.6c-.8.3-1.6 0-2-.8a14.1 14.1 0 00-13.9-9.2c-9.8 0-16.6 8-16.6 19.6 0 11.5 7.4 19.6 17.2 19.6 6 0 10.7-3 13.9-8.9.3-.7 1.2-1 1.9-.7l18.1 7.5c.8.3 1.2 1.1.8 2a37.8 37.8 0 01-35.3 20A38 38 0 01535 66c0-23.7 17.7-39.5 40.3-39.5zm304.5 0c16.2 0 27.6 6.8 34.2 20.3a1.5 1.5 0 01-.8 2l-18.1 7.6c-.8.3-1.6 0-2-.8a14.1 14.1 0 00-13.9-9.2c-9.8 0-16.6 8-16.6 19.6 0 11.5 7.4 19.6 17.2 19.6 6 0 10.5-2.8 13.7-8.5l.2-.4c.3-.7 1.2-1 1.9-.7l18.1 7.5a1.5 1.5 0 01.8 2 37.7 37.7 0 01-35.3 20A38 38 0 01839.5 66c0-23.7 17.7-39.5 40.3-39.5zm-155.9 1.6c.9 0 1.5.7 1.5 1.5v42c0 8.7 5 13.4 12.3 13.4 7.4 0 13.7-5.7 13.7-18.4v-37c0-.8.7-1.5 1.5-1.5h20c.8 0 1.4.7 1.4 1.5v72.5c0 .8-.6 1.5-1.5 1.5h-16.5c-.6 0-1.2-.5-1.4-1.2l-2.3-8.8c-3.6 6-12.7 11.8-23.8 11.8-15 0-26.3-9.7-26.3-29.4V29.6c0-.8.7-1.5 1.5-1.5h20zM642.3 1.3v34c4.2-5.3 11.9-9 22.6-9 14.8 0 26.1 9.5 26.1 29.3v46.5c0 .8-.6 1.5-1.5 1.5h-20c-.7 0-1.4-.7-1.4-1.5V60.4c0-8.9-4.9-13.7-12.2-13.7-7.1 0-13.6 5.9-13.6 18.7v36.7c0 .8-.7 1.5-1.5 1.5h-20c-.8 0-1.5-.7-1.5-1.5V4c0-.7.6-1.4 1.3-1.5l20-2.6c.8-.1 1.5.5 1.7 1.3zm304.4 0V35.2c4.3-5.2 12-8.9 22.7-8.9 14.8 0 26 9.5 26 29.3v46.5c0 .8-.6 1.5-1.4 1.5h-20c-.8 0-1.5-.7-1.5-1.5V60.4c0-8.9-4.8-13.7-12.2-13.7-7 0-13.6 5.9-13.6 18.7v36.7c0 .8-.6 1.5-1.5 1.5h-20c-.7 0-1.4-.7-1.4-1.5V4c0-.7.5-1.4 1.3-1.5L945 0c.8-.1 1.5.5 1.6 1.3zm-118 25c3.6 0 7.4.8 11.4 2.3.7.2 1 1 .9 1.7l-5 19.8a1.5 1.5 0 01-2.2 1 22 22 0 00-9.7-2.1c-7.8 0-14.2 5.2-14.2 17v36c0 .9-.6 1.6-1.5 1.6h-19.9c-.8 0-1.5-.7-1.5-1.5V29.6c0-.8.7-1.5 1.5-1.5h16.6c.7 0 1.3.6 1.4 1.3l1.6 8.9c3.8-8 12-12 20.6-12zM278 29.6c0-.8.7-1.5 1.5-1.5H296c.7 0 1.3.5 1.5 1.2l2.2 8.3c4.1-5.7 13.3-11.3 24.6-11.3 18.5 0 35.2 14.2 35.2 39.6 0 27.1-19.2 39.5-36.5 39.5-11.2 0-18.4-4.6-22-9.2V124c0 .7-.6 1.4-1.4 1.5l-19.9 2.6c-.8 0-1.6-.5-1.7-1.3V29.6zm181.1-3.3C482 26.3 500 42.2 500 66c0 23.6-18 39.5-40.8 39.5-22.6 0-40.6-15.9-40.6-39.5 0-23.7 18-39.6 40.6-39.6zm-51.7 0c3.7 0 7.5.8 11.4 2.3.7.2 1.1 1 1 1.7l-5.1 19.8a1.5 1.5 0 01-2.1 1 22 22 0 00-9.7-2.1c-7.8 0-14.2 5.2-14.2 17v36c0 .9-.7 1.6-1.5 1.6h-20c-.8 0-1.4-.7-1.4-1.5V29.6c0-.8.6-1.5 1.5-1.5h16.5c.8 0 1.4.6 1.5 1.3l1.6 8.9c3.8-8 12-12 20.5-12zm-89 20c10 0 18 7.6 18 19.6 0 11.9-7.8 19.6-18.1 19.6-10 0-17.8-7.6-17.8-19.6 0-12.1 7.8-19.7 18-19.7zm140.2 0c-9.5 0-17.2 7.7-17.2 19 0 11.1 7.7 19 17.2 19 9.7 0 17.2-7.9 17.2-19 0-11.3-7.5-19-17.2-19z" />
        <path
          d="M77.4 20.2c.9-.8 2.2-.7 3.1.4l4 5.8c2.7 4 2 9.3-1.5 12.5L28.3 89.1a2.4 2.4 0 001 4l71 18.4a9.7 9.7 0 017.1 10.4l-.7 6.1c-.1 1.1-1.1 2-2.5 1.8-58.4-15-90.7-23.4-97-25.1-7.6-2.4-8.9-11-3-16.9zm40.1 6.3a5.4 5.4 0 015.8-8.3l90.3 23.1a9.2 9.2 0 014 15.6l-69.7 64.3a5.4 5.4 0 01-9-4.5l2.9-30a78 78 0 01-30 6 88 88 0 01-45.6-13.4 2 2 0 01-.3-3l21.5-20a2 2 0 012.4-.2l.4.2a46.6 46.6 0 0046.7-2z"
          fillRule="nonzero"
        />
      </g>
    </SVG>
  );
}

export function Folder(props) {
  let checkboxOpacity = 0;
  if (props.checked === true) {
    checkboxOpacity = 1;
  }
  return (
    <SVG className={props.className} viewBox="0 0 88 63">
      <g fill="none" fillRule="evenodd">
        <path
          fill={props.checkboxColor}
          opacity={checkboxOpacity}
          fillRule="nonzero"
          d="M8.5 11.7c-.7.6-.7 1.7 0 2.3l6 5.8c.2.3.7.3 1 0L30.9 5c.6-.6.6-1.7 0-2.3-.7-.6-1.8-.6-2.4 0l-13 12.6c-.3.3-.7.3-1 0l-3.6-3.5c-.7-.6-1.8-.6-2.4 0zm17 15h-20a2 2 0 01-2-2V5.4c0-1 .8-2 2-2h13.4c1 0 1.7-.7 1.7-1.6 0-1-.8-1.7-1.7-1.7H3.4A3.4 3.4 0 000 3.3v23.4c0 1.9 1.5 3.4 3.4 3.4h24c2 0 3.4-1.5 3.4-3.4V15c0-.9-.7-1.6-1.7-1.6s-1.7.7-1.7 1.6v9.8c0 1-.9 2-2 2z"
        />
        <path
          d="M85.4 17.7H53.8l-5.9-6c-.4-.3-1-.6-1.5-.6H29c-1.2 0-2.2 1-2.2 2.2v2.2a2.2 2.2 0 104.4 0h14.3l5.8 5.9c.4.4 1 .6 1.6.6h30.4v32.6a2.2 2.2 0 100 4.3h2.1a2.2 2.2 0 002.2-2.2V19.8a2.2 2.2 0 00-2.2-2.1z"
          fill={props.iconColor}
        />
        <path
          d="M77.6 25.1H50.2l-5.8-5.8c-.4-.4-1-.7-1.6-.7H25.5c-1.2 0-2.2 1-2.2 2.2v39a2.2 2.2 0 002.2 2.3h52a2.2 2.2 0 002.2-2.2V27.3a2.2 2.2 0 00-2.1-2.2zm-16.3 20l-13.8 8a2.2 2.2 0 01-2.2 0c-.7-.4-1-1.1-1-1.9v-16a2.2 2.2 0 013.2-1.8l13.8 8a2.2 2.2 0 010 3.7z"
          fill={props.iconColor}
        />
      </g>
    </SVG>
  );
}

Folder.propsTypes = {
  className: PropTypes.String,
  iconColor: PropTypes.String,
  checkboxColor: PropTypes.String,
  checked: PropTypes.bool,
};

Folder.defaultProps = {
  className: undefined,
  iconColor: 'var(--colorBlack)',
  checkboxColor: Colors.Primary,
  checked: false,
};

export function Learn(props) {
  let checkboxOpacity = 0;
  if (props.checked === true) {
    checkboxOpacity = 1;
  }

  return (
    <SVG className={props.className} viewBox="0 0 70 62">
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.5 11.7c-.7.6-.7 1.7 0 2.3l6 5.8c.2.3.7.3 1 0L30.9 5c.6-.6.6-1.7 0-2.3-.7-.6-1.8-.6-2.4 0l-13 12.6c-.3.3-.7.3-1 0l-3.6-3.5c-.7-.6-1.8-.6-2.4 0zm17 15h-20a2 2 0 01-2-2V5.4c0-1 .8-2 2-2h13.4c1 0 1.7-.7 1.7-1.6 0-1-.8-1.7-1.7-1.7H3.4A3.4 3.4 0 000 3.3v23.4c0 1.9 1.5 3.4 3.4 3.4h24c2 0 3.4-1.5 3.4-3.4V15c0-.9-.7-1.6-1.7-1.6s-1.7.7-1.7 1.6v9.8c0 1-.9 2-2 2z"
          fill={props.checkboxColor}
          opacity={checkboxOpacity}
          fillRule="nonzero"
        />
        <g fill={props.iconColor}>
          <path d="M22.9 60.7h19.8v-2.5h-4.3v-1.8H52c2 0 3.5-1.5 3.5-3.4v-1.7a6 6 0 01-6-6h1.7c0 2.3 1.9 4.2 4.3 4.2v-4.3h6l-4.3-11.1v-1.8H42.7v-20a19.8 19.8 0 00-25 19.2V37c0 4.7 1.9 9.1 5.2 12.4v11.2zM52 35h1.7v1.7h-1.7V35zm0 3.5h1.7V40h-1.7v-1.7zm-3.4-3.5h1.7v1.7h-1.7V35zm-3.5 0H47v1.7h-1.8V35zm0 3.5H47V40h-1.8v-1.7zm-3.4-3.5h1.7v1.7h-1.7V35zm-3.4-20.6H40V16h-1.7v-1.7zm0 3.4H40v1.7h-1.7v-1.7zm0 3.5H40v1.7h-1.7v-1.7zm0 3.4H40v1.7h-1.7v-1.7zm0 3.4H40v1.8h-1.7V28zm0 3.5H40v1.7h-1.7v-1.7zm0 3.4H40v1.7h-1.7V35zm0 3.5H40V40h-1.7v-1.7zm-1.8 19.8H35v-1.8h1.7v1.8zm0-21.6H35V35h1.7v1.7zm0-6.8H35V28h1.7v1.8zm0-7H35v-1.6h1.7v1.7zm-2.5-8.5h1.7V16H34v-1.7zm-2.6 42.1h1.7v1.8h-1.7v-1.8zm-3.5 0h1.8v1.8H28v-1.8zM59 10.8h-4.3l-.4.4a21 21 0 016.4 8.4l.3.7h-6.3a2.6 2.6 0 00-2.6 2.6c0 1.4 1.2 2.6 2.6 2.6h14.6V14.3h-5.1L59 10.8z" />
          <path d="M54.7 18.6h3.6a19.7 19.7 0 00-12.2-9.7v20h14.6V28v-.8h-6a4.3 4.3 0 010-8.6z" />
        </g>
      </g>
    </SVG>
  );
}

Learn.propsTypes = {
  className: PropTypes.String,
  iconColor: PropTypes.String,
  checkboxColor: PropTypes.String,
  checked: PropTypes.bool,
};

Learn.defaultProps = {
  className: undefined,
  iconColor: 'var(--colorBlack)',
  checkboxColor: Colors.Primary,
  checked: false,
};

export function Calendar(props) {
  let checkboxOpacity = 0;
  if (props.checked === true) {
    checkboxOpacity = 1;
  }
  return (
    <SVG className={props.className} viewBox="0 0 74 61">
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.5 11.7c-.7.6-.7 1.7 0 2.3l6 5.8c.2.3.7.3 1 0L30.9 5c.6-.6.6-1.7 0-2.3-.7-.6-1.8-.6-2.4 0l-13 12.6c-.3.3-.7.3-1 0l-3.6-3.5c-.7-.6-1.8-.6-2.4 0zm17 15h-20a2 2 0 01-2-2V5.4c0-1 .8-2 2-2h13.4c1 0 1.7-.7 1.7-1.6 0-1-.8-1.7-1.7-1.7H3.4A3.4 3.4 0 000 3.3v23.4c0 1.9 1.5 3.4 3.4 3.4h24c2 0 3.4-1.5 3.4-3.4V15c0-.9-.7-1.6-1.7-1.6s-1.7.7-1.7 1.6v9.8c0 1-.9 2-2 2z"
          fill={props.checkboxColor}
          opacity={checkboxOpacity}
          fillRule="nonzero"
        />
        <g fill={props.iconColor}>
          <path d="M69.9 14.2h-6.3V17a4 4 0 01-4 4 4 4 0 01-3.9-4v-2.8H41V17a4 4 0 01-4 4 4 4 0 01-4-4v-2.8h-6.2a4 4 0 00-4 3.9v38.3a4 4 0 004 4h43a4 4 0 004-4V18.1a4 4 0 00-4-4zm1.7 42.2c0 1-.8 1.7-1.7 1.7h-43c-1 0-1.8-.7-1.8-1.7V26.6c0-1 .8-1.7 1.7-1.7h43c1 0 1.8.7 1.8 1.7v29.8z" />
          <path d="M37.1 20.3c1.6 0 2.8-1.3 2.8-3v-5.7c0-1.6-1.2-2.9-2.8-2.9-1.5 0-2.7 1.3-2.7 3v5.7c0 1.6 1.2 2.9 2.7 2.9zM59.6 20.3c1.5 0 2.7-1.3 2.7-3v-5.7c0-1.6-1.2-2.9-2.7-2.9-1.6 0-2.8 1.3-2.8 3v5.7c0 1.6 1.2 2.9 2.8 2.9zM44 29.4c0 2.3-3.5 2.3-3.5 0 0-2.2 3.4-2.2 3.4 0M50 29.4c0 2.3-3.3 2.3-3.3 0 0-2.2 3.4-2.2 3.4 0M56.2 29.4c0 2.3-3.4 2.3-3.4 0 0-2.2 3.4-2.2 3.4 0M62.3 29.4c0 2.3-3.4 2.3-3.4 0 0-2.2 3.4-2.2 3.4 0M69 29.4c0 2.3-3.3 2.3-3.3 0 0-2.2 3.4-2.2 3.4 0M31.7 35.6c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M37.8 35.6c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M44 35.6c0 2.2-3.5 2.2-3.5 0 0-2.3 3.4-2.3 3.4 0M50 35.6c0 2.2-3.3 2.2-3.3 0 0-2.3 3.4-2.3 3.4 0M56.2 35.6c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M62.3 35.6c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M69 35.6c0 2.2-3.3 2.2-3.3 0 0-2.3 3.4-2.3 3.4 0M31.7 41.7c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M37.8 41.7c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M44 41.7c0 2.2-3.5 2.2-3.5 0 0-2.3 3.4-2.3 3.4 0M50 41.7c0 2.2-3.3 2.2-3.3 0 0-2.3 3.4-2.3 3.4 0M56.2 41.7c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M62.3 41.7c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M69 41.7c0 2.2-3.3 2.2-3.3 0 0-2.3 3.4-2.3 3.4 0M31.7 48.5c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M37.8 48.5c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M44 48.5c0 2.2-3.5 2.2-3.5 0 0-2.3 3.4-2.3 3.4 0M50 48.5c0 2.2-3.3 2.2-3.3 0 0-2.3 3.4-2.3 3.4 0M56.2 48.5c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M62.3 48.5c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M69 48.5c0 2.2-3.3 2.2-3.3 0 0-2.3 3.4-2.3 3.4 0M31.7 54.6c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M37.8 54.6c0 2.2-3.4 2.2-3.4 0 0-2.3 3.4-2.3 3.4 0M44 54.6c0 2.2-3.5 2.2-3.5 0 0-2.3 3.4-2.3 3.4 0M50 54.6c0 2.2-3.3 2.2-3.3 0 0-2.3 3.4-2.3 3.4 0" />
        </g>
      </g>
    </SVG>
  );
}

Calendar.propsTypes = {
  className: PropTypes.String,
  iconColor: PropTypes.String,
  checkboxColor: PropTypes.String,
  checked: PropTypes.bool,
};

Calendar.defaultProps = {
  className: undefined,
  iconColor: 'var(--colorBlack)',
  checkboxColor: Colors.Primary,
  checked: false,
};

export function Teaching(props) {
  let checkboxOpacity = 0;
  if (props.checked === true) {
    checkboxOpacity = 1;
  }

  return (
    <SVG className={props.className} viewBox="0 0 85 62">
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.5 11.7c-.7.6-.7 1.7 0 2.3l6 5.8c.2.3.7.3 1 0L30.9 5c.6-.6.6-1.7 0-2.3-.7-.6-1.8-.6-2.4 0l-13 12.6c-.3.3-.7.3-1 0l-3.6-3.5c-.7-.6-1.8-.6-2.4 0zm17 15h-20a2 2 0 01-2-2V5.4c0-1 .8-2 2-2h13.4c1 0 1.7-.7 1.7-1.6 0-1-.8-1.7-1.7-1.7H3.4A3.4 3.4 0 000 3.3v23.4c0 1.9 1.5 3.4 3.4 3.4h24c2 0 3.4-1.5 3.4-3.4V15c0-.9-.7-1.6-1.7-1.6s-1.7.7-1.7 1.6v9.8c0 1-.9 2-2 2z"
          fill={props.checkboxColor}
          opacity={checkboxOpacity}
          fillRule="nonzero"
        />
        <g fill={props.iconColor}>
          <path d="M42.8 22.1V12h37.5v24H42.8v-2.7h-.9l-2.3-.3v4.7c0 .9.7 1.6 1.6 1.6h40.6c.9 0 1.6-.7 1.6-1.6V10.3c0-.8-.7-1.5-1.6-1.5H41.2c-.9 0-1.6.7-1.6 1.5V21l.7.9 2.5.3zM47.5 52H43c-2.5 0-4.6 2-4.6 4.6v3c0 .6.5 1 1 1h11.8c.5 0 1-.4 1-1v-3c0-2.7-2.1-4.6-4.6-4.6zM49 46.7a3.9 3.9 0 11-7.7 0 3.9 3.9 0 017.8 0M63.7 52h-4.6c-2.5 0-4.6 2-4.6 4.6v3c0 .6.5 1 1 1h11.8c.5 0 1-.4 1-1v-3c0-2.7-2-4.6-4.6-4.6zM65.3 46.7a3.9 3.9 0 11-7.8 0 3.9 3.9 0 017.8 0M79.9 52h-4.6c-2.5 0-4.6 2-4.6 4.6v3c0 .6.4 1 1 1h11.7c.6 0 1-.4 1-1v-3c0-2.7-2-4.6-4.5-4.6zM81.5 46.7a3.9 3.9 0 11-7.7 0 3.9 3.9 0 017.7 0" />
          <path d="M34 26l1.2 1.4c.9 1 2 1.6 3.4 1.7l3.8.5c1.2.2 2.3-.7 2.3-2 0-1-.8-2-1.9-2L39 25a2 2 0 01-.8-.4L35 21c-.9-1-2.1-1.5-3.4-1.5h-5.3a5 5 0 00-3.8 1.6c-2.3 3-4 6.1-5 9.7v.2c-.4.9 0 2 1 2.4.2.2.5.3.9.3a2 2 0 002-1.5v-.4c.7-2.2 1.6-4.2 3-6.1l-.1 7-1.4 15c0 1 .5 2 1.5 2.3a2 2 0 002.6-1.8l1.2-14c.1-.5.5-.9 1-.9s.8.4.9.9l1.3 14c0 1 1 1.9 2 1.9l.6-.2a2 2 0 001.4-2.2l-1.4-15V26zm-3.8 2.6l-.3.4-.6.7H29l-1-1v-.2l.7-5.8h-.3c-.2 0-.2 0-.2-.2v-1.2c0-.1 0-.2.2-.2H30v1.5h-.5l.8 5.8v.2zM33.6 13.3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0M58.6 16.3c0-.3-.1-.6-.3-.8-.4-.4-1-.4-1.5 0l-1 1-1.1-1a1 1 0 00-.8-.3c-.3 0-.6.2-.8.3a1 1 0 00-.3.8c0 .3.2.5.3.8l1 1-1 1c-.3.4-.3 1.1 0 1.6.5.4 1.2.4 1.6 0l1.1-1.1 1 1c.3.3.6.3.8.3l.8-.2c.4-.5.4-1.2 0-1.6l-1.1-1 1-1c.2-.3.3-.5.3-.8zM69.6 28.1l-.3-.7c-.4-.5-1.1-.5-1.5 0l-1 1-1.1-1c-.4-.5-1.1-.5-1.6 0-.4.4-.4 1.1 0 1.5l1.1 1-1 1.1c-.5.5-.5 1.2 0 1.6.4.4 1 .4 1.4 0l1-1 1.1 1c.3.2.5.3.8.3.3 0 .6-.2.8-.3.2-.2.3-.5.3-.8 0-.3-.2-.5-.3-.8l-1-1 1-1 .3-.9zM55.7 33.2c1.9 0 3.3-1.4 3.3-3.2 0-1.4-.9-2.6-2.2-3C57 25.8 57.9 25 59 25h4.9c2.4 0 4.3-2 4.3-4.4v-2.3l.5.5c.5.4 1.2.4 1.6 0 .4-.4.4-1.1 0-1.6L68 15.1c-.4-.5-1.1-.5-1.5 0l-2.2 2.2a1 1 0 00-.3.8c0 .3.1.6.3.8.4.4 1.1.4 1.5 0l.5-.5v2.3c0 1.2-1 2.2-2.2 2.2h-5a4.4 4.4 0 00-4.3 4 3.3 3.3 0 00-2.3 3c0 1.9 1.5 3.3 3.2 3.3zM54.6 30a1.1 1.1 0 012.3 0c0 .6-.5 1.1-1.2 1.1-.6 0-1.1-.5-1.1-1z" />
        </g>
      </g>
    </SVG>
  );
}

Teaching.propsTypes = {
  className: PropTypes.String,
  iconColor: PropTypes.String,
  checkboxColor: PropTypes.String,
  checked: PropTypes.bool,
};

Teaching.defaultProps = {
  className: undefined,
  iconColor: 'var(--colorBlack)',
  checkboxColor: Colors.Primary,
  checked: false,
};

export function Checkbox(props) {
  return (
    <SVG className={props.className} viewBox="0 0 37 35">
      <path
        fill={props.iconColor}
        fillRule="nonzero"
        d="M11.7 12.5c-.6.6-.6 1.5 0 2.1l5.4 5.2c.3.3.7.3 1 0L32 6.4c.5-.6.5-1.5 0-2-.6-.6-1.6-.6-2.2 0L18 15.5c-.3.3-.7.3-1 0l-3.2-3c-.6-.6-1.6-.6-2.2 0zM27 26H8.9c-1 0-1.8-.8-1.8-1.7V6.7C7.1 5.7 8 5 9 5h12.2c.9 0 1.6-.7 1.6-1.5S22 2 21 2h-14A3 3 0 004 5v21a3 3 0 003.1 3H29a3 3 0 003.1-3V15.5c0-.8-.7-1.5-1.5-1.5-1 0-1.6.7-1.6 1.5v8.8c0 1-.8 1.7-1.8 1.7z"
      />
    </SVG>
  );
}

Checkbox.propsTypes = {
  className: PropTypes.String,
  iconColor: PropTypes.String,
};

Checkbox.defaultProps = {
  className: undefined,
  iconColor: 'var(--colorPrimaryMedium)',
};



// WEBPACK FOOTER //
// ./src/icons/Icons.js